export class AneuploidyICDCodesClass {
  constructor(
    public O285_aneuploidy = false,
    public O283 = false,
    public O09511 = false,
    public O09512 = false,
    public O09513 = false,
    public O09521 = false,
    public O09522 = false,
    public O09523 = false,
    public O09891 = false,
    public O09892 = false,
    public O09893 = false,
    public Z3481_aneuploidy = false,
    public Z3482_aneuploidy = false,
    public Z3483_aneuploidy = false,
    public Z3401 = false,
    public Z3402 = false,
    public Z3403 = false,
    public Z360 = false,
    public otherAneuploidyICDCodes = "",
  ) {}
}
